import * as React from "react";

function SvgBlueshift(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 280 211.9"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#2A5E8E"
        d="M328.5 0c-4.9.2-9.8.7-14.8.6-8.4-.1-16.8-.4-25.2-.6h40z"
      />
      <path d="M988.4 0h-40 40z" />
      <path
        fill="#2A5E8E"
        d="M167.5 0c-4.9.2-9.8.7-14.8.6-8.1-.1-16.2-.4-24.2-.6h39z"
      />
      <path d="M833.4 0h-39 39z" />
      <path
        fill="#2A5E8E"
        d="M178.8 93.4c0-8.7-.2-17.1.2-25.4.1-1.9 1.7-4.3 3.4-5.4 8.4-5.7 17.6-8.7 27.9-8.9 14.7-.3 28.2 2.6 39.6 12.5 13.8 12.1 20.5 27.8 23.2 45.5 2.7 17.3 2.3 34.5-2.8 51.4C264 184 252.6 201 231 208.4c-16.4 5.6-32.9 5.7-48.6-3.2-2.5-1.4-3.8-3.1-3.7-6.3.2-8.7.1-17.5.1-27.1 9.2 7.8 18.5 10.3 29.3 7.6 6.6-1.6 11.7-5.2 15.8-10.3 7.5-9.4 10.9-20.3 10.9-32.4 0-9.7-.2-19.2-3.8-28.5-8.1-21.2-32.1-28.5-50.7-15.2-.2.1-.6.1-1.5.4zM128.9 2.6h38.6c-.2 68.4.2 136.5-.2 205.3-13 0-24.4.1-35.9-.1-.8 0-2.2-2.1-2.2-3.3-.1-65.1 0-130.3 0-195.4 0-2-.1-4-.3-6.5z"
      />
      <path
        fill="#0384B4"
        d="M66.2 50.1h37.1v8.5c0 47.7-.1 95.3.1 143 0 4.8-1.3 6.4-6.2 6.2-9-.4-18-.2-27-.1-3.1 0-4.5-.7-4.5-4.2.1-50.3.1-100.6.1-151 0-.6.2-1.3.4-2.4z"
      />
      <path
        fill="#61C1ED"
        d="M0 95.8h37.1v6c0 33.8-.1 67.7.1 101.5 0 3.4-1.3 4.5-6.2 4.4-9-.3-18-.1-27 0-3.1 0-4.5-.5-4.5-3 .1-35.7.1-71.5.1-107.2 0-.4.2-.9.4-1.7z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgBlueshift);
